import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, timeout} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConnectionService {
  // public url = 'https://ipv4.icanhazip.com/';
  public url = 'https://ipv4.icanhazip.com/pomodoro';
  constructor(private http: HttpClient) { }
  connection(): Observable<any>{
    return this.http.get(this.url).pipe(timeout(10), map((response: Response) => {
      return response;
    }));
  }
}
